/*
   Tipatchouli by Dylan Clement
   Theme custom — instagram.com/yndweezy
*/

(function(){
  'use strict';

  /* ═══ Mobile menu ═══ */
  var burger = document.getElementById('burger');
  var mob = document.getElementById('mobMenu');
  if(burger && mob){
    burger.addEventListener('click', function(){
      burger.classList.toggle('open');
      mob.classList.toggle('open');
      document.body.style.overflow = mob.classList.contains('open') ? 'hidden' : '';
    });
  }

  window.closeMenu = function(){
    if(burger) burger.classList.remove('open');
    if(mob) mob.classList.remove('open');
    document.body.style.overflow = '';
  };

  /* ═══ Search overlay ═══ */
  var searchOpen = document.getElementById('searchOpen');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchClose = document.getElementById('searchClose');
  var searchInput = document.getElementById('searchInput');

  function openSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ if(searchInput) searchInput.focus(); }, 100);
  }

  function closeSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if(searchInput) searchInput.value = '';
  }

  if(searchOpen) searchOpen.addEventListener('click', openSearch);
  if(searchClose) searchClose.addEventListener('click', closeSearch);

  // Close on Escape key
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('open')){
      closeSearch();
    }
  });

  // Close on click outside
  if(searchOverlay){
    searchOverlay.addEventListener('click', function(e){
      if(e.target === searchOverlay) closeSearch();
    });
  }

  /* ═══ Scroll reveal ═══ */
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('vis');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -20px 0px' });

  document.querySelectorAll('.reveal').forEach(function(el){ obs.observe(el); });

  /* ═══ Carousel arrows ═══ */
  document.querySelectorAll('.carousel-arr').forEach(function(btn){
    btn.addEventListener('click', function(){
      var wrap = this.closest('.p-carousel-wrap');
      if(!wrap) return;
      var car = wrap.querySelector('.p-carousel');
      if(!car) return;
      var card = car.querySelector('.pc');
      var amt = card ? card.offsetWidth + 14 : 300;
      var dir = parseInt(this.dataset.dir) || (this.classList.contains('arr-l') ? -1 : 1);
      car.scrollBy({ left: amt * dir, behavior: 'smooth' });
    });
  });

  /* ═══ Filter pills (collection page) ═══ */
  // Handled via links in Liquid — no JS needed for functional filters
  // Visual toggle for homepage pills:
  document.querySelectorAll('.filters .pill[type="button"], .filters button.pill').forEach(function(p){
    p.addEventListener('click', function(){
      this.parentNode.querySelectorAll('.pill').forEach(function(x){ x.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ═══ Product page: quantity ═══ */
  window.chgQty = function(d){
    var el = document.getElementById('qty');
    var input = document.getElementById('qtyInput');
    if(!el) return;
    var v = parseInt(el.textContent) + d;
    if(v < 1) v = 1;
    if(v > 10) v = 10;
    el.textContent = v;
    if(input) input.value = v;
  };

  /* ═══ Product page: accordion ═══ */
  window.toggleAcc = function(btn){
    btn.closest('.acc').classList.toggle('open');
  };

  /* ═══ Add to cart (AJAX) ═══ */
  window.addToCart = function(variantId, qty){
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      // Update cart count
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var badge = document.getElementById('cartCount');
          if(badge) badge.textContent = cart.item_count;
        });
    })
    .catch(function(err){ console.error('Cart error:', err); });
  };

  /* ═══ Cart page: update quantity ═══ */
  window.updateQty = function(key, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(){ window.location.reload(); })
    .catch(function(err){ console.error('Cart error:', err); });
  };

})();